import type { SVGProps } from 'react';
import React from 'react';

export const SearchIcon: React.FC<SVGProps<SVGSVGElement>> = ({ color = '#B6C8E3', ...props }) => (
  <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
       
      d="M16.6428 15.4596L20.9255 19.7423L19.5113 21.1565L15.2286 16.8738C13.6887 18.1058 11.7358 18.8428 9.61182 18.8428C4.64382 18.8428 0.611816 14.8108 0.611816 9.84277C0.611816 4.87477 4.64382 0.842773 9.61182 0.842773C14.5798 0.842773 18.6118 4.87477 18.6118 9.84277C18.6118 11.9668 17.8748 13.9197 16.6428 15.4596ZM14.6365 14.7176C15.8593 13.4574 16.6118 11.7384 16.6118 9.84277C16.6118 5.97527 13.4793 2.84277 9.61182 2.84277C5.74432 2.84277 2.61182 5.97527 2.61182 9.84277C2.61182 13.7103 5.74432 16.8428 9.61182 16.8428C11.5074 16.8428 13.2264 16.0903 14.4866 14.8675L14.6365 14.7176Z"
      fill={color}
    />
  </svg>
);
